import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import type { StickyHeaderNavigationProps } from '@/components/StickyHeaderNavigation/types'
import { ChevronLeft } from '@/assets/icons'
import { useTheme } from '@/hooks/useTheme'
import useOffsets from '@/hooks/useOffsets'

/**
 * Уникальный липкий хедер с гарантированно центрированным title.
 * Не влияет на общий StickyHeaderNavigation.
 */
export const StickyHeaderNavigationCentered: React.FC<
  StickyHeaderNavigationProps
> = ({
  showBackButton = true,
  title,
  rightIcon,
  marginHorizontal = 0,
  onBackPress,
  showBackground = true,
  containerStyle = {},
}) => {
  const offsets = useOffsets()
  const theme = useTheme()

  const defaultStyle: React.CSSProperties = {
    position: 'fixed',
    width: '100%',
    top: 0,
    paddingTop: offsets.top,
    zIndex: 100,
    ...(showBackground && { backgroundColor: '#131415' }),
    ...containerStyle,
  }

  return (
    <div
      data-component="sticky-header-navigation-centered"
      style={defaultStyle}
    >
      <BaseView
        row
        align="center"
        py={12}
        position="relative"
        style={{
          marginLeft: `${marginHorizontal}px`,
          marginRight: `${marginHorizontal}px`,
          minHeight: '56px',
        }}
      >
        {showBackButton && (
          <button
            onClick={onBackPress}
            style={{
              padding: '4px',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              zIndex: 10,
            }}
          >
            <ChevronLeft size={28} color={theme.colors.label.default} />
          </button>
        )}

        {title && (
          <BaseView
            flex={1}
            center
            justify="center"
            style={{
              position: 'absolute',
              left: '0px',
              right: '0px',
              top: '50%',
              transform: 'translateY(-50%)',
              // Резервируем одинаковое пространство слева/справа для идеального центра
              paddingLeft: '56px',
              paddingRight: '56px',
              zIndex: 1,
            }}
          >
            <BaseText fontSize={20} fontFamily="semibold" color="label.default">
              {title}
            </BaseText>
          </BaseView>
        )}

        {rightIcon && (
          <BaseView
            style={{
              position: 'absolute',
              right: '0px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 10,
            }}
          >
            {rightIcon}
          </BaseView>
        )}
      </BaseView>
    </div>
  )
}
